import React from "react";
import { Row, Col } from "react-bootstrap";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";

const FileUploadEmailNotificationsTable = ({ user, data, setShow, setRecord, id }) => {
  let columns = [
    {
      Header: "File Type",
      accessor: "fileTypeDescription",
      width: 200
    },
    {
      Header: "Email Subject",
      accessor: "emailSubject",
      width: 200
    },
    {
      Header: "Email Message",
      accessor: "emailMessage",
      width: 200
    },
    {
      Header: "To",
      accessor: (data) => {
        return data.assignedTo.length > 0
          ? data.assignedTo
              .filter((d) => d.sendType === "to")
              .map((e) => e.email)
              .join(", ")
          : "";
      }
    },
    {
      Header: "CC",
      accessor: (data) => {
        return data.assignedTo.length > 0
          ? data.assignedTo
              .filter((d) => d.sendType === "cc")
              .map((e) => e.email)
              .join(", ")
          : "";
      }
    },
    {
      Header: "BCC",
      accessor: (data) => {
        return data.assignedTo.length > 0
          ? data.assignedTo
              .filter((d) => d.sendType === "bcc")
              .map((e) => e.email)
              .join(", ")
          : "";
      }
    },
    {
      Header: "",
      id: "edit",
      Cell: (row) => {
        return (
          <div className='text-center'>
            <span
              className='hyperlink m-2'
              onClick={() => {
                setShow(id);
                setRecord(row.row.original);
              }}
            >
              Edit
            </span>
          </div>
        );
      },
      width: 80
    }
  ];
  return (
    <>
      <Row>
        <Col>
          <h3>File Upload Email Notification Management</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <span>Emails will come from dwadmin@utah.gov</span>
          <DtsReactTable columns={columns} data={data} headerColor='ddw' />
        </Col>
      </Row>
    </>
  );
};

export default FileUploadEmailNotificationsTable;
